import './mapme-asset.scss';
/**
 * File mapme-asset.js.
 *
 * Handle Tagular events.
 */

(() => {
	// eslint-disable-line no-unused-vars
	// Function that uses a timer for identifying whether an iframe was clicked once.
	// It does so by checking every 100ms if the active element is the specified iframe and removes the timer if so.
	// https://stackoverflow.com/questions/2381336/detect-click-into-iframe-using-javascript/32138108#32138108
	const monitor = setInterval(function () {
		// eslint-disable-next-line @wordpress/no-global-active-element
		const elem = document.activeElement;
		if (
			elem &&
			elem.tagName === 'IFRAME' &&
			elem.id.includes('mapme-asset')
		) {
			clearInterval(monitor);
			tagular('beam', 'ElementClicked', {
				'@type': 'redventures.usertracking.v3.ElementClicked',
				actionOutcome: 'INTERNALLINK',
				outboundUrl: location.href,
				correlationId: elem.parentElement.dataset?.tagCorrelationId,
				webElement: {
					elementType: 'MAPME',
					location: 'MAP',
					name: 'MAPME ASSET',
					position: 'NA',
					text: 'MAPME',
				},
			});
		}
	}, 100);
})();
